import {
    ErrorModel,
    ApiManager,
    sessionService,
    UtilityLibrary,
    AppInsightsUtility
} from '../components/ComponentsLibrary';
import { format } from 'date-fns';


const ProcessErrorData = (error, functionName, additionalData = {}) => {
    try {
        const apiProblemDetails = error?.response?.data;
        const httpStatus = error?.response?.status;

        if (error instanceof ErrorModel) {

            // If already a ErrorModel, append function name
            error.addFunctionTrace(functionName);

            // Append additional details
            Object.entries(additionalData).forEach(([key, value]) => {
                error.addErrorDetails(key, value);
            });

        }
        else {
            // Convert a generic error into a ErrorModel
            error = new ErrorModel(error.message || "Unknown error", functionName, {
                ...additionalData,
            });
        }

        if (apiProblemDetails?.detail) {
            error.ApiProblemDetails = apiProblemDetails;
            error.HttpStatus = httpStatus;
        }

        return error; // Return processed error
    }
    catch (error) {
        return error;
    }
};

const SendErrorDataToApi = async (error) => {
    try {
        let loginUserDetails = "";
        let loginUserID = 0;
        const loginUserInfo = sessionService.LoginUserInfo;
        if (loginUserInfo) {
            loginUserID = loginUserInfo.userInfoID;
            const stringBuilder = new UtilityLibrary.StringBuilder();
            stringBuilder.appendLine("UserInfoID: " + loginUserInfo.userInfoID + ", StateID: " + loginUserInfo.stateID + ", SiteID: " + loginUserInfo.siteID);
            loginUserDetails = stringBuilder.getString();
        }

        const formattedDate = format(new Date().toISOString(), 'yyyy-MM-dd-HHmmss');
        const problemId = `${formattedDate}-${Math.floor(Math.random() * 10000)}`;

        const exceptionDetails = {
            problemId: problemId, // Store unique ID            
            componentName: error.name,
            route: window.location.pathname,    
            userId: loginUserID,
            browserInfo: navigator.userAgent,
        };

        const errorLog = {
            LoginUserDetails: loginUserDetails,
            Name: error.name,
            Message: error.message,
            ErrorTrace: JSON.stringify(error.ErrorTrace), // Convert array to string
            Details: JSON.stringify(error.Details), // Convert object to string
            StackTrace: error.StackTrace, // Include stack trace
            Timestamp: new Date().toISOString(),
            AdditionalProperties: exceptionDetails,
        };

        const logPost = await ApiManager.PostLogFromWebToApi(errorLog);
        return logPost;
    }
    catch (error) {
        return error;
    }
};
const SendLogsToAppInsights = async (error) => {
    try {
        let loginUserDetails = "";
        let loginUserID = 0;
        const loginUserInfo = sessionService.LoginUserInfo;
        if (loginUserInfo) {
            loginUserID = loginUserInfo.userInfoID;
            const stringBuilder = new UtilityLibrary.StringBuilder();
            stringBuilder.appendLine("UserInfoID: " + loginUserInfo.userInfoID + ", StateID: " + loginUserInfo.stateID + ", SiteID: " + loginUserInfo.siteID);
            loginUserDetails = stringBuilder.getString();
        }
        const errorLog = {
            LoginUserDetails: loginUserDetails,
            Name: error.name,
            Message: error.message,
            ErrorTrace: JSON.stringify(error.ErrorTrace), // Convert array to string
            Details: JSON.stringify(error.Details), // Convert object to string
            StackTrace: error.StackTrace, // Include stack trace
            Timestamp: new Date().toISOString(),
        };

        const formattedDate = format(new Date(), 'yyyy-MM-dd-HHmmss');
        const problemId = `${formattedDate}-${Math.floor(Math.random() * 10000)}`;

        const exceptionDetails = {
            problemId: problemId, // Store unique ID            
            componentName: error.name,
            route: window.location.pathname,
            userId: loginUserID,
            browserInfo: navigator.userAgent,
        };

        AppInsightsUtility.trackException({
            exception: errorLog,
            severityLevel: 2, // Error severity (0-4)
            properties: exceptionDetails,
        });
    }
    catch (error) {
        return error;
    }
};  


const ManageErrorLogging = async (error, formName, methodName) => {
    const errorLog = ProcessErrorData(error, methodName, {});
    errorLog.name = formName;
    const logPost = await SendErrorDataToApi(errorLog);
}

const LogInfo = async (componentName, methodName, message, additionalData = {}) => {
    try {
        let loginUserDetails = "";
        let loginUserID = 0;
        const loginUserInfo = sessionService.LoginUserInfo;
        if (loginUserInfo) {
            loginUserID = loginUserInfo.userInfoID;
            const stringBuilder = new UtilityLibrary.StringBuilder();
            stringBuilder.appendLine("UserInfoID: " + loginUserInfo.userInfoID + ", StateID: " + loginUserInfo.stateID + ", SiteID: " + loginUserInfo.siteID);
            loginUserDetails = stringBuilder.getString();
        }

        const formattedDate = format(new Date(), 'yyyy-MM-dd-HHmmss');
        const logId = `${formattedDate}-${Math.floor(Math.random() * 10000)}`;

        const logDetails = {
            logId: logId,
            componentName: componentName,
            methodName: methodName,
            route: window.location.pathname,
            userId: loginUserID,
            browserInfo: navigator.userAgent,
            ...additionalData
        };

        const infoLog = {
            LoginUserDetails: loginUserDetails,
            Name: componentName,
            Message: message,
            Details: JSON.stringify(logDetails),
            Timestamp: new Date().toISOString(),
            LogLevel: 'Info',
            AdditionalProperties: logDetails,
        };

        // Send to API for logging
        const logPost = await ApiManager.PostLogFromWebToApi(infoLog);
        
        // Also send to App Insights for monitoring
        AppInsightsUtility.trackTrace({
            message: `${componentName}.${methodName}: ${message}`,
            severityLevel: 1, // Info level (0-4)
            properties: logDetails,
        });

        return logPost;
    } catch (error) {
        console.error('LogInfo failed:', error);
        return error;
    }
};

const LogWarning = async (componentName, methodName, message, additionalData = {}) => {
    try {
        let loginUserDetails = "";
        let loginUserID = 0;
        const loginUserInfo = sessionService.LoginUserInfo;
        if (loginUserInfo) {
            loginUserID = loginUserInfo.userInfoID;
            const stringBuilder = new UtilityLibrary.StringBuilder();
            stringBuilder.appendLine("UserInfoID: " + loginUserInfo.userInfoID + ", StateID: " + loginUserInfo.stateID + ", SiteID: " + loginUserInfo.siteID);
            loginUserDetails = stringBuilder.getString();
        }

        const formattedDate = format(new Date(), 'yyyy-MM-dd-HHmmss');
        const logId = `${formattedDate}-${Math.floor(Math.random() * 10000)}`;

        const logDetails = {
            logId: logId,
            componentName: componentName,
            methodName: methodName,
            route: window.location.pathname,
            userId: loginUserID,
            browserInfo: navigator.userAgent,
            ...additionalData
        };

        const warningLog = {
            LoginUserDetails: loginUserDetails,
            Name: componentName,
            Message: message,
            Details: JSON.stringify(logDetails),
            Timestamp: new Date().toISOString(),
            LogLevel: 'Warning',
            AdditionalProperties: logDetails,
        };

        // Send to API for logging
        const logPost = await ApiManager.PostLogFromWebToApi(warningLog);
        
        // Also send to App Insights for monitoring
        AppInsightsUtility.trackTrace({
            message: `${componentName}.${methodName}: ${message}`,
            severityLevel: 2, // Warning level (0-4)
            properties: logDetails,
        });

        return logPost;
    } catch (error) {
        console.error('LogWarning failed:', error);
        return error;
    }
};

const LogError = async (componentName, methodName, message, errorObject = null, additionalData = {}) => {
    try {
        let loginUserDetails = "";
        let loginUserID = 0;
        const loginUserInfo = sessionService.LoginUserInfo;
        if (loginUserInfo) {
            loginUserID = loginUserInfo.userInfoID;
            const stringBuilder = new UtilityLibrary.StringBuilder();
            stringBuilder.appendLine("UserInfoID: " + loginUserInfo.userInfoID + ", StateID: " + loginUserInfo.stateID + ", SiteID: " + loginUserInfo.siteID);
            loginUserDetails = stringBuilder.getString();
        }

        const formattedDate = format(new Date(), 'yyyy-MM-dd-HHmmss');
        const logId = `${formattedDate}-${Math.floor(Math.random() * 10000)}`;

        const logDetails = {
            logId: logId,
            componentName: componentName,
            methodName: methodName,
            route: window.location.pathname,
            userId: loginUserID,
            browserInfo: navigator.userAgent,
            errorStack: errorObject?.stack || 'No stack trace available',
            ...additionalData
        };

        const errorLog = {
            LoginUserDetails: loginUserDetails,
            Name: componentName,
            Message: message,
            Details: JSON.stringify(logDetails),
            StackTrace: errorObject?.stack || '',
            Timestamp: new Date().toISOString(),
            LogLevel: 'Error',
            AdditionalProperties: logDetails,
        };

        // Send to API for logging
        const logPost = await ApiManager.PostLogFromWebToApi(errorLog);
        
        // Also send to App Insights for monitoring
        AppInsightsUtility.trackException({
            exception: errorObject || new Error(message),
            severityLevel: 3, // Error severity (0-4)
            properties: logDetails,
        });

        return logPost;
    } catch (error) {
        console.error('LogError failed:', error);
        return error;
    }
};

const LoggerUtility = {
    ProcessErrorData,
    SendErrorDataToApi,
    SendLogsToAppInsights,
    ManageErrorLogging,
    LogInfo,
    LogWarning,
    LogError
};


export default LoggerUtility;
